<script setup>
import CFNavigationSidebar from '@/shared/components/CFNavigationSidebar.vue';
import CFNotificationsSidebar from '@/shared/components/CFNotificationsSidebar.vue';
import CFNotificationBell from '@/shared/components/CFNotificationBell.vue';
import CFTicketModal from '#modules/support/components/Ticket/CFTicketModal.vue';
import CFSupportCircle from '@/shared/components/CFSupportCircle.vue';
import CFSearchCircle from '@/shared/components/CFSearchCircle.vue';
import { useAccountStatus } from '@/shared/composables/useAccountStatus.js';
import CFBanners from '@/app/components/layout/CFBanners.vue';
import CFChangelogCircleButton from '@/app/components/layout/CFChangelogCircleButton.vue';
import { useAppStore } from '@/app/stores/app.store.js';
import CFMobileMenu from '@/shared/components/CFMobileMenu.vue';
import Bugsnag from '@bugsnag/js';
import { onMounted } from 'vue';
import ApplicationHydrationLoader from '@/app/components/core/ApplicationHydrationLoader.vue';
import { useAuthStore } from '#modules/auth/stores/auth.store.js';
import CFDialog from '@/shared/components/CFDialog.vue';
import CFSearchModal from '@/app/components/search/CFSearchModal.vue';

const appStore = useAppStore();
const authStore = useAuthStore();
const { hasFullAccess } = useAccountStatus();

const openMobileSidebar = () => {
    appStore.sidebarOpen = true;
    appStore.sidebarExpanded = true;
};

onMounted(() => {
    // Track when layout renders with/without user
    Bugsnag.leaveBreadcrumb('BaseLayout mounted', {
        type: 'state',
        metadata: {
            hasUser: !!authStore.user,
        },
    });
});
</script>

<template>
    <div class="flex h-full w-full overflow-hidden">
        <CFBanners />

        <template v-if="authStore.user">
            <CFNavigationSidebar />

            <main
                class="main-content"
                :class="appStore.sidebarExpanded ? 'md:ml-76' : 'md:ml-24'"
            >
                <CFMobileMenu @click="openMobileSidebar" />

                <div
                    v-if="hasFullAccess"
                    id="actionButtons"
                    class="absolute top-6 right-5 hidden items-center gap-1 lg:flex"
                >
                    <CFSearchCircle />
                    <CFSupportCircle />
                    <CFNotificationBell />
                    <CFChangelogCircleButton />
                </div>

                <slot />
            </main>

            <slot name="sidebar" />
        </template>

        <ApplicationHydrationLoader v-else />

        <CFSearchModal />
        <CFNotificationsSidebar />
        <CFTicketModal />
        <CFDialog />
    </div>
</template>
